import React from "react";
import "../../styles/ShareSidebar.css";
import { useLocation } from "react-router-dom"

const ShareSidebar = () => {
   const location = useLocation()
  
  // Creates:
  // https://www.teluguone.com/devotional/your-current-route
  const currentUrl = encodeURIComponent(
    `https://www.teluguone.com/devotional${location.pathname}`
  );

  const facebookShare = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`,
      "_blank",
      "width=600,height=500"
    );
  };

  const twitterShare = () => {


    window.open(
      `https://x.com/intent/tweet?url=${currentUrl}`,
      "_blank",
      "width=600,height=500"
    );
  };

  return (
    <div className="share-sidebar">
      <button
        className="share-btn facebook"
        onClick={facebookShare}
        aria-label="Share on Facebook"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          fill="currentColor"
          viewBox="0 0 320 512"
        >
          <path d="M279.14 288l14.22-92.66h-88.91V135.1c0-25.35 12.42-50.06 52.24-50.06H296V6.26S260.43 0 226.36 0C155.09 0 108.91 43.27 108.91 121.72V195.3H32v92.66h76.91V512h95.54V288z"/>
        </svg>
      </button>

      <button
        className="share-btn twitter"
        onClick={twitterShare}
        aria-label="Share on X"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          fill="currentColor"
          viewBox="0 0 512 512"
        >
          <path d="M389.2 48h70.6L305.6 224.2 487 464H345.4L234.4 318.4 106.5 464H35.8l165-187.7L25 48h145.3l100.4 131.5L389.2 48zM364.4 421h39.1L149.1 88H107z"/>
        </svg>
      </button>
    </div>
  );
};

export default ShareSidebar;